import React, { FC } from 'react';
import MuiListItemText, { ListItemTextProps as MuiListItemTextProps } from '@material-ui/core/ListItemText';
import { Uds } from '../../types';

export type ListItemTextProps = Uds<MuiListItemTextProps & {}>;

export const ListItemText: FC<React.PropsWithChildren<ListItemTextProps>> = ({ dataTest, ...props }) => (
  <MuiListItemText data-test={dataTest} {...props} />
);
